module.exports = {

  siteKey: "6LdYCvUhAAAAANAQE2zYUpFNCrZCvA4PRPjUJwBE",
  secretKey: "6LdYCvUhAAAAAEDl8mPBKoIDCh2o5QjbiAMMG_CT",
};
